import { ShieldCheckIcon } from '@heroicons/react/24/outline'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { SurfaceCard } from '@/components/SurfaceCard'
import { useAccountAppContext } from '@/app/AccountAppContext'

import { MfaSection } from './mfa/MfaSection'
import { PasswordSection } from './password/PasswordSection'
import { useSecurityData } from './useSecurityData'

export const Security = () => {
    const { t } = useTranslation()

    const { showError } = useAccountAppContext()
    const { data: security, isPending, error } = useSecurityData()

    useEffect(() => {
        if (error) {
            showError(error instanceof Error ? error.message : t('messages.loadError'))
        }
    }, [error, showError, t])

    if (!isPending && !security) {
        return null
    }

    if (!isPending && security?.credentialSource === 'external') {
        return (
            <SurfaceCard
                title={t('states.externalCredentialsTitle')}
                description={t('states.externalCredentialsDescription')}
            >
                <div className="text-account-secondary flex items-start gap-3 text-sm leading-6">
                    <ShieldCheckIcon className="text-account-faint mt-0.5 h-5 w-5 shrink-0" />
                    <p>{t('states.externalCredentialsBody')}</p>
                </div>
            </SurfaceCard>
        )
    }

    return (
        <>
            <PasswordSection password={security?.password} />
            <MfaSection security={security?.mfa} />
        </>
    )
}
